import { styled } from 'styled-components';
const WIDTH = 220;
const CLEAR_ICON_PADDING = 26;
const getWidth = ({ fullWidth, clearable }) => {
    if (fullWidth) {
        return '100%';
    }
    const width = clearable ? WIDTH + CLEAR_ICON_PADDING * 2 : WIDTH;
    return `${width}px`;
};
export const DateFields = styled.div `
  display: flex;
  width: ${getWidth};
  > * {
    min-width: calc(50% - 5px);
    max-width: calc(50% - 5px);
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
`;
